import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import NoSSR from 'vue-no-ssr';
import Wrapper from '../components/shared/_any/Wrapper'
import PageColumns from "../components/shared/PageColumns";
import inViewportDirective from 'vue-in-viewport-directive'
Vue.component('vue-no-ssr', NoSSR);
Vue.component('PageColumns', PageColumns);
Vue.component('Wrapper', Wrapper);

// Smooth scroll
import vueSmoothScroll from 'vue-smooth-scroll'

Vue.use(vueSmoothScroll);
Vue.use(VueScrollTo);// Smooth scroll
// In-viewport directive



Vue.directive('in-viewport', inViewportDirective);




// WEBPACK FOOTER //
// ./plugins/global.js